import React, { useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BlogCard from "./BlogCard";
import { ImageProvider } from "../../../utils/image-provider";
import { Link } from "gatsby";

const BlogsSection = ({ data }) => {
  const {
    cards = [],
    heading,
    heading_color,
    watermark_1,
    watermark_2,
  } = data || {};

  // to avoid Focusable descendents within an [aria-hidden="true"]
  const sliderRef = useRef(null);

  const fixSlickAriaHidden = () => {
    if (!sliderRef.current) return;

    const root = sliderRef.current.innerSlider?.list; // slick "list" DOM node
    if (!root) return;

    // Make hidden slide interactive elements unfocusable
    root
      .querySelectorAll(
        '.slick-slide[aria-hidden="true"] a, .slick-slide[aria-hidden="true"] button, .slick-slide[aria-hidden="true"] [tabindex]',
      )
      .forEach((el) => el.setAttribute("tabindex", "-1"));

    // Restore focus for visible slides
    root
      .querySelectorAll(
        '.slick-slide[aria-hidden="false"] a, .slick-slide[aria-hidden="false"] button',
      )
      .forEach((el) => el.removeAttribute("tabindex"));
  };

  useEffect(() => {
    // run once after first render
    setTimeout(fixSlickAriaHidden, 0);
  }, []);

  const sliderSettings = {
    dots: true,
    arrows: true,
    infinite: cards.length > 3,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      {
        breakpoint: 828,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: true,
        },
      },
    ],
    afterChange: () => fixSlickAriaHidden(),
  };

  return (
    <div className="relative w-full m-auto xl:px-[8%] py-[4vh] bg-white overflow-hidden">
      {/* Watermarks */}
      {watermark_1?.url && (
        <ImageProvider
          Image={watermark_1}
          alt={watermark_1.alternativeTextt || "Image"}
          tailwindStyle={`hidden xl:block pointer-events-none absolute left-0 top-0 w-[25vw]  h-auto opacity-80 z-0`}
        />
      )}
      {watermark_2?.url && (
        <ImageProvider
          Image={watermark_2}
          alt={watermark_2?.alternativeText || "Image"}
          tailwindStyle={`hidden xl:block pointer-events-none absolute right-0 top-0 w-[25vw] h-auto opacity-80 z-0`}
        />
      )}

      {/* Section Heading */}
      {heading && (
        <h2
          className="text-[6vw] xl:text-[3vw] font-bold text-center mb-[4vh]"
          style={{ color: heading_color || "#000" }}
        >
          {heading}
        </h2>
      )}

      {/* Blog Cards */}
      {cards.length > 0 && (
        <div className="w-[85%] lg:w-full m-auto lg:pb-[2vw] z-10 blog-slider">
          <Slider {...sliderSettings}>
            {cards.map((card, index) => (
              <div key={index} className="px-0 xl:px-[0.5vw]">
                <BlogCard data={card} />
              </div>
            ))}
          </Slider>
        </div>
      )}
      <div className="flex justify-center items-center lg:pt-[2vw] pt-[3vw]">
        <Link to="/blog">
          <button className="font-redhatMedium lg:text-[1.3vw] text-[4.5vw] bg-primary text-white lg:px-[2vw] px-[5vw] lg:py-[0.5vw] py-[1.5vw] lg:rounded-[0.5vw] rounded-[1.5vw]">
            Know More
          </button>
        </Link>
      </div>
    </div>
  );
};

export default BlogsSection;
